import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
	CreateVoyageTemplateLazy
} from "@containers/singleVoyage/voyageTemplates/mutateTemplate/createTemplate/CreateVoyageTemplate.lazy";

const CreateVoyageTemplatePage = () => {

	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<CreateVoyageTemplateLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default CreateVoyageTemplatePage;
